// src/utils/dashboardDates.js
// ชีทที่พิมพ์ปีผิด (เจอจริง: 12 แถวลงวันที่ 20280328 ในไฟล์ WINTER) ทำให้ "วันที่
// ล่าสุด" กระโดดไปอนาคต และ KPI ฟอร์ม 7 วันล่าสุดกลายเป็นการนับเฉพาะแถวที่พิมพ์ผิด
// เลยต้องมองข้ามวันที่ล่วงหน้าตอนหา "ล่าสุด" แต่ยังนับเกมพวกนั้นในสถิติรวมตามเดิม
// (ไม่ไปตัดข้อมูลของทีมเอง) และบอกจำนวนไว้ให้ไปแก้ที่ชีท

// คีย์ล่วงหน้าวันสองวันเป็นเรื่องปกติ (คนละไทม์โซน/ลงตารางไว้ก่อน) — เกินหนึ่งสัปดาห์
// ถึงจะถือว่าพิมพ์ผิด อย่างแถว 20280328 ที่ล่วงหน้าเป็นปี
export const FUTURE_GRACE_DAYS = 7;

export function todayYmd(now = new Date()) {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}${m}${d}`;
}

function shiftYmd(ymd, days) {
  const y = Number(String(ymd).slice(0, 4));
  const m = Number(String(ymd).slice(4, 6));
  const d = Number(String(ymd).slice(6, 8));
  if (!y || !m || !d) return String(ymd);
  return todayYmd(new Date(y, m - 1, d + days));
}

export function normalizeYmd(value) {
  const s = String(value ?? "").replace(".0", "").trim();
  return /^\d{8}$/.test(s) ? s : "";
}

/**
 * @returns {{ dates: string[], latest: string, futureCount: number }}
 *   dates       วันที่ที่ใช้ได้ เรียงใหม่ → เก่า (ตัดวันที่ล่วงหน้าออก)
 *   latest      วันที่ล่าสุดที่เกิดขึ้นจริงแล้ว ("" ถ้าไม่มี)
 *   futureCount จำนวนเกมที่ลงวันที่ล่วงหน้า — เอาไว้เตือนว่าชีทพิมพ์ผิด
 */
export function playedDates(games, today = todayYmd(), graceDays = FUTURE_GRACE_DAYS) {
  const all = (Array.isArray(games) ? games : [])
    .map((g) => normalizeYmd(g?.Date))
    .filter(Boolean);
  const limit = shiftYmd(today, graceDays);
  const future = all.filter((d) => d > limit);
  const dates = all.filter((d) => d <= limit).sort((a, b) => b.localeCompare(a));

  // ถ้าทุกแถวเป็นอนาคตหมด (ไฟล์ทดสอบ/ตั้งวันที่ล่วงหน้าทั้งไฟล์) ก็ใช้ตามที่มี
  if (!dates.length && future.length) {
    const sorted = [...future].sort((a, b) => b.localeCompare(a));
    return { dates: sorted, latest: sorted[0], futureCount: 0 };
  }
  return { dates, latest: dates[0] || "", futureCount: future.length };
}
